import { c as _c } from "react/compiler-runtime";
import type { ApiCreateGroupDescription } from "@/generated/models/ApiCreateGroupDescription";
import type { ApiGroupOwnsNft } from "@/generated/models/ApiGroupOwnsNft";
import { ApiGroupOwnsNftNameEnum } from "@/generated/models/ApiGroupOwnsNft";
import { CheckIcon } from "@heroicons/react/24/outline";
const COLLECTIONS = [{
  name: "Gradients",
  enum: ApiGroupOwnsNftNameEnum.Gradients
}, {
  name: "Memes",
  enum: ApiGroupOwnsNftNameEnum.Memes
}, {
  name: "Memelab",
  enum: ApiGroupOwnsNftNameEnum.Memelab
}, {
  name: "Nextgen",
  enum: ApiGroupOwnsNftNameEnum.Nextgen
}];
export default function GroupCreateCollections(t0) {
  const $ = _c(9);
  const {
    nfts,
    setNfts
  } = t0;
  let t1;
  if ($[0] !== nfts || $[1] !== setNfts) {
    t1 = collection => {
      const existingCollection = nfts.find(n => n.name === collection);
      if (existingCollection?.tokens.length === 0) {
        setNfts(nfts.filter(n_0 => n_0.name !== collection));
      } else {
        const newCollection = {
          name: collection,
          tokens: []
        };
        const filteredNfts = nfts.filter(n_1 => n_1.name !== collection);
        setNfts([...filteredNfts, newCollection]);
      }
    };
    $[0] = nfts;
    $[1] = setNfts;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggleCollection = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><p className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-50">Collection Access</p><p className="tw-mb-0 tw-mt-0.5 tw-text-sm tw-text-iron-500">Identity must own any token from these collections.</p></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== nfts || $[5] !== toggleCollection) {
    t3 = COLLECTIONS.map(collection_0 => {
      const existingCollection_0 = nfts.find(n_2 => n_2.name === collection_0.enum);
      const isSelected = existingCollection_0?.tokens.length === 0;
      return <button key={collection_0.enum} onClick={() => toggleCollection(collection_0.enum)} className={`tw-flex tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-px-3 tw-py-2.5 tw-text-left tw-transition-colors ${isSelected ? "tw-border-primary-500/50 tw-bg-primary-500/10 tw-text-primary-400" : "tw-border-white/5 tw-bg-iron-900 tw-text-iron-300 hover:tw-border-white/10 hover:tw-bg-iron-800 hover:tw-text-iron-100"}`}><span className="tw-min-w-0 tw-truncate tw-text-sm tw-font-medium">{collection_0.name}</span>{isSelected && <CheckIcon aria-hidden="true" className="tw-size-4 tw-flex-shrink-0 tw-text-primary-400" />}</button>;
    });
    $[4] = nfts;
    $[5] = toggleCollection;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="tw-rounded-xl tw-border tw-border-solid tw-border-white/5 tw-bg-iron-950 tw-p-3 tw-shadow-inner sm:tw-p-5">{t2}<div className="tw-mt-2 sm:tw-mt-4"><div className="tw-grid tw-grid-cols-2 tw-gap-3">{t3}</div></div></div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}